var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "content" }, [
    _c("div", { staticClass: "warning" }, [
      _c("img", {
        attrs: {
          src: require("../../../assets/trumpet@2x.png"),
          width: "18px",
          height: "18px",
        },
      }),
      _c("span", { staticClass: "warning_font" }, [_vm._v("库存告急")]),
      _c(
        "div",
        { on: { click: _vm.toList } },
        [
          _c(
            "el-carousel",
            {
              staticStyle: {
                width: "400px",
                "margin-left": "10px",
                cursor: "pointer",
              },
              attrs: {
                height: "20px",
                interval: 2000,
                direction: "vertical",
                "indicator-position": "none",
                autoplay: true,
              },
            },
            _vm._l(3, function (item) {
              return _c("el-carousel-item", { key: item }, [
                _c("div", [
                  _vm._v("奥利司他胶囊九华康 — 仅剩" + _vm._s(item) + "件"),
                ]),
              ])
            }),
            1
          ),
        ],
        1
      ),
    ]),
    _c(
      "div",
      { staticClass: "top" },
      [
        _c(
          "el-row",
          [
            _c("el-col", { attrs: { span: 8 } }, [
              _c(
                "div",
                {
                  staticClass: "left",
                  staticStyle: { "border-right": "4px solid #F5F5F5" },
                },
                [
                  _c("div", { staticClass: "top" }, [
                    _c(
                      "div",
                      {
                        staticClass: "top_size",
                        staticStyle: {
                          display: "flex",
                          "align-items": "center",
                        },
                      },
                      [
                        _c("div", {
                          staticStyle: {
                            border: "2px solid #2D7EDF",
                            display: "inline-block",
                            height: "12px",
                            "margin-right": "10px",
                          },
                        }),
                        _c(
                          "span",
                          {
                            staticStyle: {
                              display: "inline-block",
                              "font-weight": "600",
                              "font-size": "17px",
                              color: "#333",
                            },
                          },
                          [_vm._v(" 未完成数据 ")]
                        ),
                      ]
                    ),
                  ]),
                  _c("div", { staticClass: "bottom" }, [
                    _c("div", { staticClass: "NoOrderInStock" }, [
                      _c(
                        "span",
                        {
                          staticStyle: {
                            "font-weight": "400",
                            "font-size": "13px",
                            color: "#333333",
                            "text-align": "left",
                          },
                        },
                        [_vm._v("未备货订单数")]
                      ),
                      _c("span", { staticStyle: { "text-align": "center" } }, [
                        _vm._v(
                          _vm._s(_vm._f("filterName")("物流审批-待备货", this))
                        ),
                      ]),
                    ]),
                    _c("div", { staticClass: "NoOrderInStock" }, [
                      _c(
                        "span",
                        {
                          staticStyle: {
                            "font-weight": "400",
                            "font-size": "13px",
                            color: "#333333",
                            "text-align": "left",
                          },
                        },
                        [_vm._v("未发货订单数")]
                      ),
                      _c("span", { staticStyle: { "text-align": "center" } }, [
                        _vm._v(
                          _vm._s(_vm._f("filterName")("物流审批-已备货", this))
                        ),
                      ]),
                    ]),
                  ]),
                ]
              ),
            ]),
            _c("el-col", { attrs: { span: 16 } }, [
              _c(
                "div",
                {
                  staticClass: "left",
                  staticStyle: {
                    "min-width": "360px",
                    "border-left": "4px solid rgb(245,245,245)",
                  },
                },
                [
                  _c("div", { staticClass: "top" }, [
                    _c(
                      "div",
                      {
                        staticClass: "top_size",
                        staticStyle: {
                          display: "flex",
                          "align-items": "center",
                        },
                      },
                      [
                        _c("div", {
                          staticStyle: {
                            border: "2px solid #2D7EDF",
                            display: "inline-block",
                            height: "12px",
                            "margin-right": "10px",
                          },
                        }),
                        _c(
                          "div",
                          {
                            staticStyle: {
                              display: "inline-block",
                              "font-weight": "600",
                              "font-size": "17px",
                            },
                          },
                          [_vm._v(" 订单总汇 ")]
                        ),
                      ]
                    ),
                  ]),
                  _c("div", { staticClass: "bottom" }, [
                    _c("div", { staticClass: "NoOrderInStock" }, [
                      _c(
                        "span",
                        {
                          staticStyle: {
                            "font-weight": "400",
                            "font-size": "13px",
                            color: "#333333",
                            "text-align": "left",
                          },
                        },
                        [_vm._v(_vm._s("订单日总汇"))]
                      ),
                      _c("span", { staticStyle: { "text-align": "center" } }, [
                        _vm._v(
                          _vm._s(_vm._f("filterName")("订单日总汇", this))
                        ),
                      ]),
                    ]),
                    _c("div", { staticClass: "NoOrderInStock" }, [
                      _c(
                        "span",
                        {
                          staticStyle: {
                            "font-weight": "400",
                            "font-size": "13px",
                            color: "#333333",
                            "text-align": "left",
                          },
                        },
                        [_vm._v(_vm._s("订单近七天总汇"))]
                      ),
                      _c("span", { staticStyle: { "text-align": "center" } }, [
                        _vm._v(
                          _vm._s(_vm._f("filterName")("订单近七天总汇", this))
                        ),
                      ]),
                    ]),
                    _c("div", { staticClass: "NoOrderInStock" }, [
                      _c(
                        "span",
                        {
                          staticStyle: {
                            "font-weight": "400",
                            "font-size": "13px",
                            color: "#333333",
                            "text-align": "left",
                          },
                        },
                        [_vm._v(_vm._s("订单当月总汇"))]
                      ),
                      _c("span", { staticStyle: { "text-align": "center" } }, [
                        _vm._v(
                          _vm._s(_vm._f("filterName")("订单当月总汇", this))
                        ),
                      ]),
                    ]),
                  ]),
                ]
              ),
            ]),
          ],
          1
        ),
      ],
      1
    ),
    _c("div", { staticClass: "bottom" }, [
      _vm._m(0),
      _c("div", { staticClass: "echarts" }, [
        _c(
          "div",
          {
            staticStyle: {
              flex: "1",
              display: "flex",
              "justify-content": "space-between",
              "flex-direction": "column",
            },
          },
          [
            _vm._m(1),
            _c(
              "div",
              { staticClass: "contextBorder" },
              _vm._l(_vm.inventoryData.出库, function (item, index) {
                return _c(
                  "div",
                  {
                    key: item.label,
                    staticClass: "context",
                    staticStyle: { "margin-right": "40px" },
                  },
                  [
                    _c("span", { staticStyle: { "font-size": "14px" } }, [
                      _vm._v(_vm._s(item.label)),
                    ]),
                    _c("div", { staticClass: "contextChil" }, [
                      _c(
                        "span",
                        {
                          staticStyle: {
                            "font-size": "24px",
                            "font-weight": "600",
                            color: "#333333",
                            "text-align": "center",
                          },
                        },
                        [_vm._v(_vm._s(item.value))]
                      ),
                    ]),
                  ]
                )
              }),
              0
            ),
          ]
        ),
        _c(
          "div",
          {
            staticStyle: {
              flex: "1",
              "justify-content": "space-between",
              "flex-direction": "column",
            },
          },
          [
            _vm._m(2),
            _c(
              "div",
              { staticClass: "contextBorder" },
              _vm._l(_vm.inventoryData.入库, function (item, index) {
                return _c(
                  "div",
                  {
                    key: item.label,
                    staticClass: "context",
                    staticStyle: { "margin-right": "40px" },
                  },
                  [
                    _c("span", { staticStyle: { "font-size": "14px" } }, [
                      _vm._v(_vm._s(item.label)),
                    ]),
                    _c("div", { staticClass: "contextChil" }, [
                      _c(
                        "span",
                        {
                          staticStyle: {
                            "font-size": "24px",
                            "font-weight": "600",
                            color: "#333333",
                            "text-align": "center",
                          },
                        },
                        [_vm._v(_vm._s(item.value))]
                      ),
                    ]),
                  ]
                )
              }),
              0
            ),
          ]
        ),
      ]),
    ]),
    _vm._m(3),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "topBorder" }, [
      _c("div", { staticClass: "top" }, [
        _c(
          "div",
          {
            staticClass: "top_size",
            staticStyle: {
              "min-width": "219px",
              display: "flex",
              "align-items": "center",
            },
          },
          [
            _c("div", {
              staticStyle: {
                border: "2px solid #2D7EDF",
                display: "inline-block",
                height: "12px",
                "margin-right": "10px",
              },
            }),
            _c(
              "div",
              {
                staticStyle: {
                  display: "inline-block",
                  "font-weight": "600",
                  "font-size": "17px",
                },
              },
              [_vm._v(" 库存数据 ")]
            ),
          ]
        ),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "title" }, [
      _c("div", {
        staticStyle: {
          border: "2px solid #2D7EDF",
          display: "inline-block",
          height: "10px",
          "margin-right": "10px",
        },
      }),
      _c("span", [_vm._v("出库数据")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "title" }, [
      _c("div", {
        staticStyle: {
          border: "2px solid #2D7EDF",
          display: "inline-block",
          height: "10px",
          "margin-right": "10px",
        },
      }),
      _c("span", [_vm._v("入库数据")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "div",
      {
        staticStyle: {
          display: "flex",
          padding: "10px 20px",
          background: "#fff",
        },
      },
      [
        _c("div", {
          staticStyle: { width: "45%", height: "450px" },
          attrs: { id: "chartLineBox" },
        }),
        _c("div", {
          staticStyle: { width: "45%", height: "450px" },
          attrs: { id: "chartLineBox1" },
        }),
      ]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }